module.exports = __webpack_public_path__ + "static/media/24UHCHR10.a84736e3.jpg";